import { NotFoundError } from "@sportactics/errors";

export class TeamNotFoundError extends NotFoundError {
  constructor(id: string) {
    super("Team", id.toString());
    this.name = TeamNotFoundError.name;
  }
}
